import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieConsent from './components/feature/CookieConsent';
import useImageProtection from './hooks/useImageProtection';

function App() {
  useImageProtection();

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
